var _ellipse, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 147,
    viewBox: "0 0 158 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79,
    cy: 73.0824,
    rx: 79,
    ry: 73.0824,
    fill: "#008DFF",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.223 64.5352V53.3544C104.223 46.5999 101.546 40.1222 96.7798 35.3461C92.0139 30.57 85.55 27.8868 78.81 27.8868C72.0699 27.8868 65.606 30.57 60.8401 35.3461C56.0742 40.1222 53.3967 46.5999 53.3967 53.3544V64.5352",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6984 85.9654C84.6997 84.872 84.413 83.7977 83.8672 82.8509C83.3214 81.9042 82.5359 81.1186 81.59 80.5735C80.6442 80.0284 79.5716 79.7432 78.4805 79.7467C77.3894 79.7501 76.3186 80.0421 75.3763 80.5932C74.4339 81.1442 73.6534 81.9348 73.1136 82.885C72.5737 83.8352 72.2938 84.9113 72.3019 86.0047C72.3101 87.0981 72.6061 88.1699 73.16 89.1119C73.714 90.0539 74.5062 90.8327 75.4567 91.3695C75.7275 91.5313 75.9509 91.7617 76.1043 92.0377C76.2578 92.3136 76.3359 92.6252 76.3307 92.9411V96.7861C76.3307 97.1287 76.4665 97.4573 76.7083 97.6996C76.9501 97.9419 77.278 98.0781 77.6199 98.0781H80.0001C80.342 98.0781 80.67 97.9419 80.9117 97.6996C81.1535 97.4573 81.2894 97.1287 81.2894 96.7861V92.5435C81.2937 92.2394 81.3709 91.9407 81.5144 91.6727C81.6578 91.4046 81.8633 91.175 82.1137 91.003C82.9122 90.4288 83.5631 89.6726 84.0125 88.7967C84.4619 87.9208 84.697 86.9503 84.6984 85.9654V85.9654Z",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116 107.576H41V111.576H116V107.576Z",
    fill: "#75FB91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3967 64.2247H47.1983C45.635 64.2247 44.1357 64.847 43.0302 65.9549C41.9248 67.0627 41.3037 68.5652 41.3037 70.1319V112.371C41.3037 113.938 41.9248 115.44 43.0302 116.548C44.1357 117.656 45.635 118.278 47.1983 118.278H109.802C111.365 118.278 112.864 117.656 113.97 116.548C115.075 115.44 115.696 113.938 115.696 112.371V70.1319C115.696 68.5652 115.075 67.0627 113.97 65.9549C112.864 64.847 111.365 64.2247 109.802 64.2247H104.223",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.6fb6a2a1943475827e6e7b3f3f753a3a.svg";
export { ForwardRef as ReactComponent };